export interface FaviconProps {
  imageUrl?: string | undefined;
}

/**
 * Compoent set favicon to document
 * @param props
 * @returns
 */
export function Favicon(props: FaviconProps) {
  const { imageUrl } = props;

  if (imageUrl) {
    return <link rel="icon" type="image/x-icon" sizes="32x32" href={imageUrl} />;
  }

  return (
    <>
      <link rel="apple-touch-icon" sizes="180x180" href="/assets/favicon/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/assets/favicon/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/assets/favicon/favicon-16x16.png" />
      <link rel="manifest" href="/assets/favicon/site.webmanifest" />
      <link rel="mask-icon" href="/assets/favicon/safari-pinned-tab.svg" color="#5bbad5" />
    </>
  );
}
